import React, { useEffect, useState } from "react";
import "./centralEquipmentModal.css";
import { CentralModal } from "../CentralModal/CentralModal";
import { CentralSelect } from "../CentralSelect/CentralSelect";
import { CentralInputField } from "../CentralInputField/CentralInputField";
import {
  AVAILABILITY,
  EQUIPMENT_CATEGORY,
  EQUIPMENT_ETO,
  EQUIPMENT_TYPE,
  PROVIDED_BY,
  UTILIZATION_STATUS,
} from "./constant";
import { useDispatch, useSelector } from "react-redux";
import {
  centralAddOrDeleteInstrumentsService,
  centralEquipmentDropdownService,
} from "../../../_services";
import { getTokenFromLocal } from "../../../_helpers/handleResponseMiddleware";
import { centralEquipmentsActions } from "../../../_actions/centralActions/centralEquipments.actions";
import { toast } from "react-toastify";
import { configActions } from "../../../_actions";

export const CentralEquipmentModal = React.memo((props) => {
  const {
    open,
    onClose,
    onAddMore,
    onOpen,
    instrumentsOptions,
    equipmentType = "",
  } = props;
  const reportingData = useSelector((state) => state.centralReportingData);
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    equipmentCategory: "",
    quantity: "",
    providedBy: "",
    availability: "",
    utilizationStatus: "",
    instrumentType: "",
    itemSpecification: "",
    equipmentBrand: "",
    equipmentItem: "",
    equipmentETO: "",
  });

  const [instrumentsDetails, setInstrumentsDetails] = useState({
    equipmentCategory: [],
    equipmentBrands: [],
    consumableItems: [],
    equipmentItems: [],
  });
  const [isInstrumentType, setIsInstrumentType] = useState(false);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  
  useEffect(async () => {
    if (formData.instrumentType && formData.instrumentType !== "Instrument") {
      if (reportingData && reportingData?.reportingData?.data?.length) {
        const category = reportingData?.reportingData?.data[0]?.category;
        setIsInstrumentType(false);

        try {
          const params = { type: formData.instrumentType };
          const res = await centralEquipmentDropdownService(params);
          if (res?.status === 200 && res?.newEquipmentsData?.length > 0) {
            if (formData.instrumentType === "Equipment") {
              const equipmentCat =
                res.newEquipmentsData[0][formData.instrumentType][category] ||
                [];
              if (equipmentCat && equipmentCat?.length) {
                setInstrumentsDetails((prev) => ({
                  ...prev,
                  equipmentCategory: [
                    ...equipmentCat.map((item) => ({
                      label: item,
                      value: item,
                    })),
                  ],
                  equipmentBrands: [],
                  equipmentItems: [],
                }));
              } else {
                setInstrumentsDetails((prev) => ({
                  ...prev,
                  equipmentCategory: [],
                  equipmentBrands: [],
                  equipmentItems: [],
                }));
              }
            }
            if (formData.instrumentType === "Implant") {
              const details = res.newEquipmentsData[0][formData.instrumentType];
              setInstrumentsDetails((prev) => ({
                ...prev,
                equipmentCategory: [
                  ...details.itemName?.map((item) => ({
                    label: item,
                    value: item,
                  })),
                ],
                equipmentBrands: [
                  ...details.Brand?.map((item) => ({
                    label: item,
                    value: item,
                  })),
                ],
                equipmentItems: [],
              }));
            }
            if (formData.instrumentType === "Consumable") {
              const details = res.newEquipmentsData[0][formData.instrumentType];
              const categoryDetails = details[category] || [];
              if (Object.keys(categoryDetails)?.length > 0) {
                const keys = Object.keys(categoryDetails);
                setInstrumentsDetails((prev) => ({
                  ...prev,
                  equipmentCategory: [
                    ...keys.map((item) => ({ label: item, value: item })),
                  ],
                  equipmentBrands: [
                    ...details.Brand?.map((item) => ({
                      label: item,
                      value: item,
                    })),
                  ],
                  consumableItems: categoryDetails,
                }));
              } else {
                setInstrumentsDetails((prev) => ({
                  ...prev,
                  equipmentCategory: [],
                  equipmentBrands: [],
                  equipmentItems: [],
                }));
              }
            }
          }
        } catch (err) {
          console.error("Error fetching data:", err);
          toast.error(`Unable to get ${formData.instrumentType} details`);
        }
      }
    } else if (formData.instrumentType === "Instrument") {
      setIsInstrumentType(true);
    }
  }, [formData.instrumentType]);

  const handleChange = (name, value) => {
    if (name === "instrumentType") {
      setFormData((prev) => ({
        ...prev,
        equipmentCategory: "",
        equipmentBrand: "",
        equipmentItem: "",
        equipEto:""
      }));
    }
    if (name === "equipmentCategory") {
      if (formData.instrumentType === "Consumable") {
        setInstrumentsDetails((prev) => {
          const items = prev.consumableItems?.[value] || [];

          return {
            ...prev,
            equipmentItems: items.map((item) => ({
              label: item,
              value: item,
            })),
          };
        });
      }
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleOnClose = () => {
    onClose();
    setFormData((prev) => ({
      ...prev,
      equipmentCategory: "",
      quantity: "",
      instrumentType: "",
      itemSpecification: "",
      providedBy: "",
      availability: "",
      utilizationStatus: "",
      equipmentBrand: "",
      equipmentItem: "",
      equipmentETO: "",
    }));
    setIsInstrumentType(false);
  };

  const handleOnSubmit = () => {
    let user = getTokenFromLocal();
    let userName = user ? user.username || user?.name : null;
    let appId = "";
    if (reportingData && reportingData.activePatientId) {
      dispatch(configActions.showSpinningLoader());
      appId = reportingData.activePatientId;
      const params = {
        deleteInstrument: [],
        newInstruments: [
          {
            equipCategory: formData.equipmentCategory,
            equipName: formData.equipmentItem,
            equipBrand: formData.equipmentBrand,
            equipEto: formData.equipmentETO === "Yes" ? true : false,
            equipType: formData.instrumentType,
            // itemSpecification: formData.itemSpecification,
            providedBy: formData.providedBy,
            status: formData.availability,
            quantity: formData.quantity,
            utilisationStatus: "used",
            createdAt: `${new Date().toISOString()}`,
            userName: userName,
            source: "hosChatApp",
          },
        ],
        appId: appId,
        createdAt: `${new Date().toISOString()}`,
      };

      centralAddOrDeleteInstrumentsService(params)
        .then((response) => {
          if (response.message === "Success") {
            toast.success("Instrument Added Successfully");
            dispatch(
              centralEquipmentsActions.getCentralInstrumentsList({
                appId: appId,
              })
            );
          }
          dispatch(configActions.hideSpinningLoader());
        })
        .catch((err) => {
          console.log("Add new equipment error", err);
          dispatch(configActions.hideSpinningLoader());
        });
      onAddMore();
      handleOnClose();
    }
  };

  useEffect(() => {
    const item  = formData.instrumentType === 'Consumable' ? formData.equipmentItem : true
    if (
      formData.equipmentCategory &&
      formData.instrumentType &&
      formData.providedBy &&
      formData.availability &&
      item
    ) {
      setIsSubmitDisabled(false);
    } else {
      setIsSubmitDisabled(true);
    }
  }, [formData, instrumentsDetails]);

  return (
    <CentralModal
      modalTitle="Add Item"
      open={open}
      onClose={handleOnClose}
      buttonTitle="Save"
      isShowDivider={true}
      isSubmitDisabled={isSubmitDisabled}
      onSubmit={handleOnSubmit}
      isModalFooterShow={true}
      modalButton={
        <div className="addMoreButton" onClick={() => onOpen()}>
          Add +
        </div>
      }
    >
      <div className="equipmentContentContainer">
        <CentralSelect
          value={formData.instrumentType || ""}
          label="Type *"
          options={EQUIPMENT_TYPE}
          onChange={(event) =>
            handleChange("instrumentType", event.target.value)
          }
        />
        {!isInstrumentType ? (
          <>
            <CentralSelect
              value={formData.equipmentCategory || ""}
              disabled={!formData?.instrumentType}
              label="Name *"
              options={instrumentsDetails.equipmentCategory || []}
              onChange={(event) =>
                handleChange("equipmentCategory", event.target.value)
              }
            />
            {instrumentsDetails.equipmentItems?.length > 0 ? (
              <CentralSelect
                value={formData.equipmentItem || ""}
                disabled={!formData?.equipmentCategory}
                label="Item *"
                options={instrumentsDetails.equipmentItems || []}
                onChange={(event) =>
                  handleChange("equipmentItem", event.target.value)
                }
              />
            ) : (
              ""
            )}
            {instrumentsDetails.equipmentBrands?.length > 0 ? (
              <CentralSelect
                value={formData.equipmentBrand || ""}
                disabled={!formData?.equipmentCategory}
                label="Brand"
                options={instrumentsDetails.equipmentBrands || []}
                onChange={(event) =>
                  handleChange("equipmentBrand", event.target.value)
                }
              />
            ) : (
              ""
            )}
          </>
        ) : (
          <>
            <CentralInputField
              value={formData.equipmentCategory || ""}
              label="Name *"
              handleOnChange={(event) =>
                handleChange("equipmentCategory", event.target.value)
              }
            />
            <CentralSelect
              value={formData.equipmentETO || ""}
              label="ETO"
              options={EQUIPMENT_ETO || []}
              onChange={(event) =>
                handleChange("equipmentETO", event.target.value)
              }
            />
          </>
        )}
        {/* <CentralInputField
          value={formData.itemSpecification || ""}
          label="Item Specification"
          handleOnChange={(event) =>
            handleChange("itemSpecification", event.target.value)
          }
          maxLength={70}
        /> */}
        <CentralInputField
          value={formData.quantity || ""}
          label="Quantity"
          handleOnChange={(event) =>
            handleChange("quantity", event.target.value)
          }
          type={"number"}
        />
        <CentralSelect
          value={formData.providedBy || ""}
          label="Provided By *"
          options={PROVIDED_BY}
          onChange={(event) => handleChange("providedBy", event.target.value)}
        />
        <CentralSelect
          value={formData.availability || ""}
          disabled={!formData?.providedBy}
          label="Availability *"
          options={AVAILABILITY}
          onChange={(event) => handleChange("availability", event.target.value)}
        />
        {/* <CentralSelect value={formData.utilizationStatus || ''} disabled = {!formData?.providedBy} label="Utilization Status*" options={UTILIZATION_STATUS} onChange={(event) => handleChange('utilizationStatus', event.target.value)}/> */}
      </div>
    </CentralModal>
  );
});
